import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { SubmitHypactProfileCommand } from '@/app/hypact-profile/commands/submit-hypact-profile.command'

const httpClient = new AxiosClient()

export const submitHypactProfileCommand = new SubmitHypactProfileCommand(httpClient, store)
